import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import ApplicationApproval from "./views/ApplicationApproval.vue";
import SoftUnderwriting from "./views/SoftUnderwriting.vue";
import FinalUnderwriting from "./views/FinalUnderwriting.vue";
import FundingGate from "./views/FundingGate.vue";
import Dashboard from "./views/Dashboard.vue";
import Register from "./views/Register.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/application",
      name: "Application Approval",
      component: ApplicationApproval,
    },
    {
      path: "/softunderwriting",
      name: "Soft Underwriting",
      component: SoftUnderwriting,
    },
    {
      path: "/finalunderwriting",
      name: "Final Underwriting",
      component: FinalUnderwriting,
    },
    {
      path: "/funding",
      name: "Funding Gate",
      component: FundingGate,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/register/:user_id",
      name: "Register",
      component: Register,
    },
  ],
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
